import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './error.module.scss';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';

interface IProps {
    chooseDifferentBank: () => void,
    finishConnection: () => void,
}

const DataSharingCancelled: React.FC<IProps> = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.screen} data-testid='error-container'>
            <div className={styles.topWrapper}>
                <h1>{t<string>('Bank data sharing cancelled')}</h1>
                <div className={styles.content}>
                    {t<string>('None of your bank data was shared')}
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <PrimaryButton onClick={props.chooseDifferentBank}>{t<string>('Choose a different bank')}</PrimaryButton>
                <SecondaryButton onClick={props.finishConnection}>{t<string>('Quit')}</SecondaryButton>
            </div>
        </div>);
};

export default DataSharingCancelled;
